import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/* import jwt_decode from 'jwt-decode' */
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable, of } from 'rxjs';
/* import { MiddlemanService } from '../../@helper/Middleman.service' */
import { environment } from '../../../environments/environment';
import { MiddlemanService } from '../../auth/services/Middleman.service';
import { Settings } from '../interfaces/common/settings';
const helper = new JwtHelperService()
@Injectable({
  providedIn: 'root',
})
export class UserStore {
  private getthemesettings = '/settings/current'
  getStorage: any | undefined;
  private getthemesettingspost = '/settings/currentpost'
  private UpdateRepIdsettings = '/settings/currentRepsetId'
  private updateCurrentBranch = '/settings/currentBranch'
  private getbranchlinks = '/api/Transactions/branchlistreturned'
  private getbranchlinksAll = '/api/Transactions/branchlistSuperuserreturned'
  private rolesource = new BehaviorSubject<string>('')
  currentRole = this.rolesource.asObservable()
 private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  constructor(
    private http: HttpClient,
/*     private authService: NbAuthService, */
    private _nextclear: MiddlemanService,
  ) {
    this.getStorage = localStorage.getItem(this.authLocalStorageToken);
  }

  setSetting(
    themeName: string,
    currentroles: string,
    branchnumbersamw: string,
  ): Observable<Settings> {
    if (themeName) {
      if (branchnumbersamw === undefined) {
        branchnumbersamw = ''
      }
      if (localStorage.getItem(this.authLocalStorageToken)) {
        const pushtheme = {
          ThemeName: themeName,
          RoleId: currentroles,
          BranchNumber: branchnumbersamw,
        }
        return this.http.post<any>(this.getthemesettingspost, pushtheme)
      } else {
        return of({ themeName: 'dark' })
      }
    } else {
      return of({ themeName: themeName })
    }
  }

  UpdateRepIdAsSuperAdmin(sa: any): Observable<any> {
    return this.http.put<any>(this.UpdateRepIdsettings, sa)
  }

  setCurrentBranch(branchNumber: string): Observable<any> {
    return this.http.put<any>(this.updateCurrentBranch, {
      BranchNumber: branchNumber,
    })
  }

  Getbranchlinks(): Observable<any> {
    return this.http.get<any>(this.getbranchlinks)
  }

  Getbranchlinksall(): Observable<any> {
    return this.http.get<any>(this.getbranchlinksAll)
  }

  loadrole(roletext: string) {
    this.rolesource.next(roletext)
  }

  getRole(): Observable<any[]> {
  const tokenData = localStorage.getItem(this.authLocalStorageToken);
  let jsonArr = [];

  if (tokenData) {
    try {
      const parsed = JSON.parse(tokenData);
      const token = parsed?.token;
      const payload = this.getDecodedAccessToken(token);

      if (Array.isArray(payload?.role)) {
        for (let i = 0; i < payload.role.length; i++) {
          jsonArr.push({
            role: payload.role[i],
            rolevalue: `${payload.rolename[i]}|${payload.role[i]}`,
          });
        }
      } else {
        jsonArr.push({
          role: payload?.role,
          rolevalue: `${payload?.rolename}|${payload?.role}`,
        });
        
      }

      this._nextclear.notifyrefreshmenu();
    } catch (error) {
      console.error('Token parsing error:', error);
    }
  }

  return of(jsonArr);
}


  getDecodedAccessToken(token: any): any {
    return helper.decodeToken(token)
  }
}
